// Simple script to create an admin user directly
// Run this in the browser console on the auth page

import { auth, db } from './firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';

window.createAdminUser = async (email, password) => {
  try {
    console.log('Creating admin user...');
    
    // Create the user
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    console.log('User created:', user.uid);
    
    // Add user profile to Firestore with admin role
    await setDoc(doc(db, 'users', user.uid), {
      email: email,
      role: 'admin',
      isMember: true,
      membershipDate: new Date(),
      createdAt: new Date()
    });
    
    console.log('Admin user created successfully!');
    return { success: true, uid: user.uid };
  } catch (error) {
    console.error('Error creating admin user:', error);
    return { success: false, error: error.message };
  }
};

console.log('Admin creation function loaded. Use: createAdminUser("your-email@example.com", "your-password")');
